// extracted by mini-css-extract-plugin
export default {"poster":"Project_poster__aR4Ir","form":"Project_form__90XFJ","iframeContainer":"Project_iframeContainer__wzgCx"};